import { AvailableWarehouse } from '@forms/CreateOutboundShipmentNoteForm/types';

interface WarehouseStockEntry {
  warehouseId: string;
  availableStock: number;
}

export function pickWarehouseWithStock(
  stockByWarehouse: WarehouseStockEntry[] | undefined,
  availableWarehouseOptions: AvailableWarehouse[] | undefined
): AvailableWarehouse['warehouse'] | null {
  if (!stockByWarehouse?.length || !availableWarehouseOptions?.length) {
    return null;
  }

  const stockedWarehouse = stockByWarehouse.find(
    (stock) => stock.availableStock > 0
  );
  if (!stockedWarehouse) return null;

  return (
    availableWarehouseOptions.find(
      (option) => option.warehouse.warehouseId === stockedWarehouse.warehouseId
    )?.warehouse ?? null
  );
}
